export default __webpack_public_path__ + "static/media/TypeThatTune.d33c0eeb.jpg";